import { instance } from "@/lib/hooks";

export const fetchQuickSightDashboardEmbedUrl = async (dashboardId: string) => {
  const response = await instance.get<{ EmbedUrl: any }>(
    `/dashboards/urls/${dashboardId}`
  );

  return response.data;
};
